
import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import whitelabelModule from '@/store/whitelabel'
import WhitelabelEditor from '@/components/whitelabel/WhitelabelEditor.vue'
import AdminList from '@/components/whitelabel/admin/AdminList.vue'

@Component({
  name: 'WhitelabelList',
  components: {
    AdminList,
    WhitelabelEditor
  }
})
class WhitelabelList extends Vue {
  private get auth() {
    return authModule
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private async created(): Promise<void> {
    if (!this.whitelabel) {
      await whitelabelModule.fetch(this.$route.params.wid)
    }
  }
}

export default WhitelabelList
